window.addEventListener('DOMContentLoaded', function () {
  var OKJS = window.OKJS;

  OKJS.Navigation.init();
  OKJS.Search.init();
  OKJS.BeforeAfterSlider.init();
  OKJS.Blocks.init();
  OKJS.Overlay.init();
  OKJS.Press.init();
  OKJS.Quicklinks.init();
  OKJS.Share.init();
  OKJS.StickyHeader.init();
  OKJS.Survey.init();
  OKJS.VideoSetup.init();
  OKJS.Factbox.init();
});
